import { Component, OnInit, AfterViewInit } from '@angular/core';
import { HelpButtonComponent } from '../../admin/help-info/help-button/help-button.component';
import { AuthTokenService } from '../../auth/auth-token.service';
import { LoggerService } from '../../shared/logger/logger.service';
import { Subscription } from 'rxjs';
import { Route, Router, RouterLink, RouterLinkActive } from '@angular/router';
import { DiscoverOpportunityComponent } from '../shared/discover-opportunity/discover-opportunity.component';
import { CommonModule } from '@angular/common';
import { SearchAustraliaLinkComponent } from '../shared/search-australia-link/search-australia-link.component';
import { IconBlockComponent } from '../shared/icon-block/icon-block.component';
import { ApiService } from '../../api/api.service';
import { TrackerApiService } from '../../api/tracker-api.service';

@Component({
  selector: 'app-content',
  standalone: true,
  imports: [
    CommonModule,
    RouterLink, RouterLinkActive,
    HelpButtonComponent,
    DiscoverOpportunityComponent,
    SearchAustraliaLinkComponent,
    IconBlockComponent
  ],
  templateUrl: './content.component.html',
  styleUrl: './content.component.scss'
})
export class ContentComponent implements OnInit, AfterViewInit {

  private _subs: Subscription[] = [];
  loggedIn: boolean = this.authTokenService.loggedIn;
  public message: string | null = null;

  constructor(
    private authTokenService: AuthTokenService,
    private logger: LoggerService,
    private router: Router,
    private apiService: ApiService,
    private tracker: TrackerApiService
  ) { }

  ngOnInit(): void {
    this.logger.debug('ngOnInit...');
    this.tracker.logActivity('Home Page', this);
    this._subs.push(this.authTokenService.isLoggedIn$.subscribe(status => {
      this.logger.debug('ngOnInit:status: ', status);
      this.loggedIn = status;
      if (this.loggedIn)
        this.router.navigate(['/logged-in']);

    }));

    this.apiService.getHttpCallAsPromise(`control`, 'get').then((data) => {
      this.logger.debug('got control', data);
      if (data && data.home_page_banner)
        this.message = data.home_page_banner;


    }).catch((error) => {

    });

  }

  ngAfterViewInit(): void {
    setTimeout(() => window.scrollTo({ top: 0, left: 0, behavior: "instant" }));
  }


}
